import React from 'react';
import PropTypes from 'prop-types';
import {accordion, accordionTrigger, accordionBody, triggerLabel as triggerLabelClass} from './style.module.scss';
import ExpandIcon from 'src/svgs/action/expand.svg';

export const Accordion = ({
  children,
  descriptiveLabel,
  expanded,
  onToggle,
  tabIndex,
  triggerLabel,
}) => (
  <div className={accordion}>
    <button
      tabIndex={tabIndex}
      className={accordionTrigger}
      aria-label={descriptiveLabel}
      aria-expanded={expanded}
      onClick={() => onToggle()}
    >
      <div className={triggerLabelClass}>{triggerLabel}</div>
      <ExpandIcon />
    </button>
    <div className={accordionBody} aria-hidden={!expanded}>
      {children}
    </div>
  </div>
);

Accordion.propTypes = {
  children: PropTypes.node.isRequired,
  descriptiveLabel: PropTypes.string,
  expanded: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
  tabIndex: PropTypes.number,
  triggerLabel: PropTypes.node.isRequired,
};
